import Fade from "@mui/material/Fade";
import pxToRem from "../functions/pxToRem";

// Ink tooltips in light mode; inverted in dark mode so they still stand off the page.
export default function tooltip({ tokens, mode, typography, borders }) {
  const { size, fontWeightRegular } = typography;
  const { borderRadius } = borders;
  const background = mode === "dark" ? tokens.text : tokens.ink;
  const foreground = mode === "dark" ? tokens.ink : tokens["on-ink"];

  const tooltip = {
    defaultProps: {
      arrow: true,
      TransitionComponent: Fade,
    },

    styleOverrides: {
      tooltip: {
        maxWidth: pxToRem(200),
        backgroundColor: background,
        color: foreground,
        fontSize: size.sm,
        fontWeight: fontWeightRegular,
        textAlign: "center",
        borderRadius: borderRadius.md,
        opacity: 0.92,
        padding: `${pxToRem(5)} ${pxToRem(8)} ${pxToRem(4)}`,
      },

      arrow: {
        color: background,
      },
    },
  };

  return tooltip;
}
